import axios from 'axios';
import { constant } from '../../constant';

// Dedicated client for the typography admin API. Same pattern as Seo/seoApi.js:
// validateStatus:()=>true so 4xx responses resolve and callers can surface
// res.data.errors (server-side validation messages) in the UI.
const client = axios.create({ baseURL: constant.baseUrl, validateStatus: () => true });

const authHeaders = () => ({ Authorization: localStorage.getItem('token') });

export const getTypography = () => client.get('typography', { headers: authHeaders() });
// settings: { roles, groups } (site-wide roles + page-group overrides)
export const saveTypographyDraft = (settings) =>
  client.put('typography/draft', settings, { headers: authHeaders() });
export const publishTypography = () =>
  client.post('typography/publish', {}, { headers: authHeaders() });
export const revertTypography = (changeLogId) =>
  client.post('typography/revert', { changeLogId }, { headers: authHeaders() });
// Renders unpublished settings to CSS for the real-page preview (nothing is saved).
export const previewTypographyCss = (settings) =>
  client.post('typography/preview-css', settings, { headers: authHeaders(), responseType: 'text' });

// History lives in the shared SEO change log, filtered to typography entries.
export const getTypographyHistory = (params) =>
  client.get('seo/history', { headers: authHeaders(), params: { ...params, entityType: 'typography' } });

export default {
  getTypography,
  saveTypographyDraft,
  publishTypography,
  revertTypography,
  previewTypographyCss,
  getTypographyHistory,
};
